import React, { useState } from 'react';
import { Container, Form, FloatingLabel, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LanguageProvider } from '../../core/language-provider';
import { ApiManager } from '../../core/api-manager';
import loginBg from '../../assets/login.jpg';


export default function Login() {

    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState('');


    async function handleSubmit(e) {
        e.preventDefault();

        var body = {
            email: username,
            password: password
        }
        const response = await ApiManager.sendRequest('/public/login_standard', body);
        console.log(response)
        if(response.success === 1) {
            var b = JSON.parse(response.body)
            if(b.access_token) {
                window.location.href = "/nl_page/AutoLogin?token=" + b.access_token
            }
            else {
                setErrors("Le credenziali inserite sono errate.")
            }
        }
        else {
            setErrors("Non è stato possibile effettuare il login. Riprova.")
        }
    }





    return (
        <Container fluid id="login-container" style={{"backgroundImage": `url('${loginBg}')`}}>
            <div className="form-signin">
                <Form onSubmit={handleSubmit}>
                    <div className="mb-3 mt-2 text-center">
                        <h4>{LanguageProvider.get('login.title')}</h4>
                        <p>{LanguageProvider.get('login.subtitle')}</p>
                    </div>

                    <FloatingLabel label={LanguageProvider.get('login.username')}>
                        <Form.Control type="text" placeholder="name@example.com" onChange={e => setUserName(e.target.value)} />
                    </FloatingLabel>

                    <div className="mb-3" style={{ position: 'relative' }}>
                        <FloatingLabel label={LanguageProvider.get('login.password')}>
                            <Form.Control type={showPassword ? "text" : "password"} placeholder="password" onChange={e => setPassword(e.target.value)} style={{ paddingRight: '45px' }} />
                        </FloatingLabel>
                        <span onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', fontSize: '14px' }}>
                            <FontAwesomeIcon icon={showPassword ? 'eye-slash' : 'eye'} />
                        </span>
                    </div>

                    <div className="mb-3 mt-2">
                        <Form.Check type="checkbox" label={LanguageProvider.get('login.remember')} />
                    </div>
                
                    <div className="mb-3 text-center">
                        <Button className="btn-block w-100" variant="primary" size="lg" type="submit">{LanguageProvider.get('login.login')}</Button>
                    </div>
                    <div className="mb-3 text-center">
                        <a href="https://crm.fedespedi.it/signup">
                            <Button className="btn-block w-100" variant="outline-primary" size="lg">Registrati</Button>
                        </a>
                    </div>

                    {errors.length > 0 &&
                        <Alert variant='danger'>
                            {errors}
                        </Alert>
                    }
                </Form>
                <div className="text-center">
                    <a href="https://crm.fedespedi.it/forgot-password">{LanguageProvider.get('login.forgot')}</a>
                </div>
            </div>
        </Container>
    );
};